/*
 * Copyright (c) 2019 LabKey Corporation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import React, { FC } from 'react';

import { Alert } from '../base/Alert';

const DEFAULT_MESSAGE = 'You do not have permissions for this action.';
export const InsufficientPermissionsAlert: FC<{ message?: string }> = ({ message = DEFAULT_MESSAGE }) => (
    <Alert className="wrong-perms-alert">{message}</Alert>
);
InsufficientPermissionsAlert.displayName = 'InsufficientPermissionsAlert';
